// =============================================================================
//  Copyright : 2024 semantics GmbH
//  Date      : $Date: 2025-09-21 19:16:35 +0200 (Sun, 21 Sep 2025) $
//  Author    : Dirk Rothe
//  Worker    : $Author: d.rothe $
//  Revision  : $Rev: 156393 $
//  Purpose   : transcription hooks
// =============================================================================
// ---Third-party imports

// ---Framework imports
import {get} from 'ldash'

import log from 'uix/logging'
import {useApi, useRouter} from 'uix/hooks'

export const useApiWithPuid = (name, params = {}, apiopts = {}) => {
  let {request} = useRouter()
  let puid = String(request.id).startsWith('pu') ? request.id.slice(2) : null
  return useApi(name, puid ? {id: puid, ...params} : params, apiopts)
}
